export const MIN_VISIBLE = 4;
export const MAX_VISIBLE = 7;
